<!--
  提现
  lovi 2020-1-9
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('wallet.withdraw')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />

    <div class="scroll-wrapper">
      <van-cell-group>
        <van-cell
          :icon="
            require('@/assets/images/wallet/withdraw/icon_' +
              (index == 0
                ? 'withdraw'
                : index == 1
                ? 'order'
                : index == 2
                ? 'bank'
                : 'alipay') +
              '@2x.png')
          "
          :title="item.type_name"
          :label="item.detail"
          v-for="(item, index) in listData"
          :key="index"
          is-link
          @click.native="linkFun(item, index)"
        />
      </van-cell-group>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "withdraw",
  meta: {
    keepAlive: true
  },
  components: {},
  data() {
    return {
      listData: [],
      tx_raming: ""
    };
  },
  created() {
    this.$store.dispatch("GET_USER_INFO");
    this._getWithdrawalList();
  },
  mounted() {},
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    linkFun(data, index) {
      let vm = this;
      console.log("index", index);
      if (index == 0) {
        if (vm.userInfo.bank_count == 0) {
          vm.$dialog
            .confirm({
              message: vm.$t("bankCard.notBoundBankCardTips"),
              confirmButtonText: vm.$t("common.confirm"),
              cancelButtonText: vm.$t("common.cancel")
            })
            .then(() => {
              // on confirm
              // 绑定银行卡
              vm.$router.push({
                path: "/bankCard"
              });
            })
            .catch(() => {
              // on cancel
            });
          return;
        }
        this.$router.push({
          path: "/withdrawBank",
          name: "withdrawBank"
        });
      }
      if (index > 0) {
        this.$router.push({
          path: "/withdrawOther",
          name: "withdrawOther",
          query: { type: index == 1 ? 9 : index == 2 ? 10 : 11 }
        });
      }
    },
    _getWithdrawalList() {
      // 提现方式列表
      let vm = this;
      vm.$post("/app/pay/withdrawalList", {}, { loading: true }).then(res => {
        console.log("withdrawalList", res);
        vm.listData = res.list;
        vm.tx_raming = res.tx_raming;
      });
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped>
.scroll-wrapper {
  /deep/.van-cell-group {
    .van-cell {
      display: flex;
      align-items: center;
      .van-cell__left-icon,
      .van-cell__left-icon img {
        width: 36px;
        height: 36px;
      }
      .van-cell__title {
        span {
          line-height: 20px;
        }
        .van-cell__label {
          margin-top: 0;
          font-size: 12px;
          line-height: 16px;
        }
      }
    }
  }
}
</style>
